import { ApiRequest } from '../baseService'

// System Configuration → "AI – LOI Specialty & Accreditation": the tenant's
// rules for the Doc QA Result's Specialty and Accreditation rows.
const BaseRoute = 'app/loi-credential-settings'

export interface LoiRuleCondition {
  reportTypes: string[]
  schemes: string[]
  contexts: string[]
  states: string[]
  requesters: string[]
  /** true = joint instruction only, false = not joint, null/undefined = either */
  joint?: boolean | null
  /** true = impairment requested, false = not requested, null/undefined = either */
  impairment?: boolean | null
}

export interface LoiAccreditationRule {
  id: string
  name: string
  enabled: boolean
  when: LoiRuleCondition
  require: string[]
  reason: string
}

export interface LoiCredentialRuleSet {
  version: number
  alwaysRequired: { accreditation: string; reason: string }[]
  rules: LoiAccreditationRule[]
  amaEditionDefaults: { when: LoiRuleCondition; edition: number }[]
  amaLabelFormat: string
  credentialPhrases: { keywords: string[]; accreditation: string }[]
  specialtyDisciplines: { discipline: string; keywords: string[] }[]
}

export interface LoiCredentialSettingsDto {
  rules: LoiCredentialRuleSet
  defaultRules: LoiCredentialRuleSet
  isDefault: boolean
  storedRulesUnreadable: boolean
  options: {
    reportTypes: string[]
    schemes: string[]
    contexts: string[]
    states: string[]
    requesters: string[]
    accreditations: string[]
    specialties: string[]
  }
  warnings: string[]
}

const query = (tenantId?: string) => (tenantId ? `?tenantId=${tenantId}` : '')

const Get = (tenantId?: string) =>
  ApiRequest.get<LoiCredentialSettingsDto>(`${BaseRoute}${query(tenantId)}`)

const Update = (tenantId: string | undefined, rules: LoiCredentialRuleSet) =>
  ApiRequest.put<LoiCredentialSettingsDto>(
    `${BaseRoute}${query(tenantId)}`,
    rules
  )

/** Back to the built-in default rules. */
const Reset = (tenantId?: string) =>
  ApiRequest.delete<LoiCredentialSettingsDto>(`${BaseRoute}${query(tenantId)}`)

const API = { Get, Update, Reset }

export default API
